export const frontmatter = {
    "draft": true,
    "title": "Autenticación de dos factores",
    "description": "Configura la autenticación en dos factores (2FA) en OnnIA.",
    "sidebar_label": "2FA",
    "sidebar_group": "referencia",
    "sidebar_order": 4
}

export const toc = []